import { render } from "./slug.vue?vue&type=template&id=1d4f017b"
import script from "./slug.vue?vue&type=script&lang=js"
export * from "./slug.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__